<div class="jds-icon-inner" [innerHTML]="svgContent | async"></div>
